import React, { useState } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Link from './link';
import './styles.css';
import SpeikLogo from './speikLogo';
import Sidebar from './sidebar';
import { isLoggedIn, logout } from '../service/auth';
import HamburgerMenu from './burgerButton';

const Header = ({ location }) => {
  const [burgerOpen, openBurger] = useState(false);
  return (
    <StaticQuery
      query={graphql`
        query headerTitleQuery {
          site {
            siteMetadata {
              headerTitle
              logo
              headerLinks {
                link
                text
              }
            }
          }
        }
      `}
      render={data => {
        const {
          site: {
            siteMetadata: { headerTitle, headerLinks }
          }
        } = data;
        return (
          <div className={'navBarWrapper'}>
            <div className={'navbar navbar-default navBarDefault'}>
              <div className={'navbar-header'}>
                <HamburgerMenu
                  isOpen={false}
                  menuClicked={() => {
                    openBurger(!burgerOpen);
                  }}
                  style={{
                    position: 'relative',
                    right: '12px',
                    top: '21px',
                    width: '32px',
                    height: '24px',
                    float: 'right'
                  }}
                  width={32}
                  height={24}
                  strokeWidth={3}
                  color={'black'}
                  animationDuration={0.5}
                  type="button"
                  className={'collapsed navBarToggle'}
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar"
                />
                <Link
                  to="/GettingStarted"
                  className={'navbar-brand navBarBrand'}
                >
                  <SpeikLogo
                    width={166}
                    height={65}
                    marginRight={'45px'}
                    top={'-4px'}
                    position={'relative'}
                    left={'20px'}
                    cursor={'pointer'}
                  />
                  {headerTitle}
                </Link>
              </div>
              <div
                id="navbar"
                className={'navbar-collapse collapse navBarCollapse'}
              >
                <div className={'visible-xs'}>
                  <Sidebar location={location} />
                  <hr />
                </div>
                <ul className={'nav navbar-nav navBarUL navbar-right'}>
                  {headerLinks.map((link, key) => {
                    if (link.link !== '' && link.text !== '') {
                      return (
                        <li key={key}>
                          <a href={link.link} target="_blank">
                            {link.text}
                          </a>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
              {isLoggedIn() && (
                <button
                  onClick={() => {
                    logout();
                  }}
                  className={'hide-logout-button'}
                  style={{
                    padding: '6px 12px 8px 12px',
                    background: '#51c2a0',
                    border: 'none',
                    borderRadius: '7px',
                    color: 'white',
                    fontWeight: 600
                  }}
                >
                  Log out
                </button>
              )}
            </div>
          </div>
        );
      }}
    />
  );
};
export default Header;
